import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-security-risk-tooltip',
  templateUrl: './security-risk-tooltip.component.html',
  styleUrls: ['./security-risk-tooltip.component.css']
})
export class SecurityRiskTooltipComponent implements OnInit {

  @Input() securityRisk: string;
  @Input() showDarkIcon: string;
  
  config = {
    Insignificant: {
      travelRisk:
        "It is possible to travel freely. Levels of violent crime are very low though isolated incidents may occur. There is some risk from petty crime.",
      authorisationToTravel:
        "Normally no Pre -Trip Travel  approval from HSE or country management required unless there is a temporary travel restriction in place.",
    },
    Low: {
      travelRisk:
        "Travelers face few problems. There is a possibility of disruption by state and non-state people (such as demonstrations) though these pose little physical threat. Common sense precautions will minimize the risk from crime to ALARP.  Any low-level terrorist campaign poses only incidental risk to travellers.",
      authorisationToTravel:
        "Normally no Pre -Trip Travel  approval from HSE or country management required unless there is a temporary travel restriction in place.",
    },
    Medium: {
      travelRisk:
        "Travel is possible but may be subject to disruption by state or non-state people, which may pose a physical risk. Levels of violent crime (including kidnapping) and/or terrorist attacks pose some risk: caution is required.",
      authorisationToTravel:
        "Pre-Trip Travel approval from HSE or country management required.",
    },
    High: {
      travelRisk:
        "Travel is potentially dangerous and requires careful planning. State or non-state people are likely to disrupt travel; protection by the authorities is inadequate. Terrorism, political unrest or high levels of violent crime (including kidnapping) pose a serious risk, with foreign travellers likely to be targeted or at increased risk of incidental exposure to violence.",
      authorisationToTravel:
        "Pre-Trip Travel approval from HSE or country management required",
    },
    Extreme: {
      travelRisk:
        "Travel is dangerous and should be avoided. Authorities are unable or unwilling to provide protection. High levels of violence or terrorism persist, and foreign travellers can be specific targets.",
      authorisationToTravel:
        "No travel permitted . Only Security Advisors may travel with Basin level approval.",
    },
  };

  constructor() { }

  ngOnInit(): void {
  }

  getData(item: string) {
    return this.config[this.securityRisk][item];
  }

}
